import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { CalendarClock } from "lucide-react";

export const StageScheduleDialog = ({ pending, onCancel, onConfirm }) => {
  const [date, setDate] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (pending) { setDate(""); setNotes(""); setSaving(false); } }, [pending]);

  const confirm = async () => {
    setSaving(true);
    try { await onConfirm(new Date(date).toISOString(), notes.trim()); } finally { setSaving(false); }
  };
  const block = (e) => e.preventDefault();

  return (
    <Dialog open={!!pending} onOpenChange={() => {}}>
      <DialogContent data-testid="stage-schedule-dialog" onInteractOutside={block} onEscapeKeyDown={block} className="[&>button]:hidden">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><CalendarClock size={18} className="text-[#D95D1E]" /> {pending?.stage} — {pending?.name}</DialogTitle>
          <DialogDescription>The next visit date & time and notes are mandatory for this stage.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><label className="text-sm font-semibold">Next visit date & time *</label>
            <Input type="datetime-local" value={date} onChange={(e) => setDate(e.target.value)} data-testid="stage-schedule-date-input" /></div>
          <div><label className="text-sm font-semibold">Notes *</label>
            <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} placeholder="Purpose of the visit, who will meet, etc." data-testid="stage-schedule-notes-textarea" /></div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel} data-testid="stage-schedule-cancel-btn">Don't change stage</Button>
          <Button onClick={confirm} disabled={!date || !notes.trim() || saving} className="btn-orange" data-testid="stage-schedule-save-btn">Save & Update Stage</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
